import { ParticipanteResponse, RegistroStatus, RegistroResponse, TipoAcessoParticipante } from 'common/genericTypes';
import moment from 'moment';

const initialRegistroResponse: RegistroResponse = {
  id: '',
  ticket: '',
  suspenso: false,
  dataDeCriacao: new Date(),
  status:
    RegistroStatus.AguardandoCorrecao ||
    RegistroStatus.Aprovado ||
    RegistroStatus.EmAnalise ||
    RegistroStatus.Reprovado ||
    RegistroStatus.Excluido ||
    RegistroStatus.AguardandoAprovacaoEdicao,
  registroHistoricos: [],
};

export const initialParticipante: ParticipanteResponse = {
  id: '',
  ticket: '',
  dataCriacao: moment(),
  tipoAcesso: TipoAcessoParticipante.Participante,
  funcoes: [],
  cnpj: '',
  razaoSocial: '',
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  uf: '',
  telefones: [],
  atividadePrincipalDesenvolvida: '',
  faturamentoMedioMensalUltimosDozeMeses: 0,
  razaoSocialBancoLiquidante: '',
  ispbBancoLiquidante: '',
  agenciaBancoLiquidante: '',
  contaBancoLiquidante: '',
  inscricaoEstadual: '',
  inscricaoMunicipal: '',
  grupoEconomico: '',
  representantesLegais: [],
  documentos: [],
  usuarios: [],
  registro: initialRegistroResponse,
  avaliadoPeloKyc: false
};
